import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { processLink } from '../../utils/shortPinItem';

export const toggleEcardKeyStatus = createAsyncThunk(
  "ecards/toggleKeyStatus",
  async ({ key, token }, { rejectWithValue }) => {

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/bio-pages/${key}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {

        return { id: key, response: response.data.response }
      } else {
        return rejectWithValue("Failed to toggle key status");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Error toggling key status"
      );
    }
  }
);

export const EditEcard = createAsyncThunk(
  "ecards/editcard",
  async ({ token, id, formData }, { rejectWithValue }) => {
    try {

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/bio-pages/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },

        }
      );

      if (response.data.status) {

        return response.data.response
      } else {
        return rejectWithValue("Failed to Edit");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Error  "
      );
    }
  }
)

export const EcardmoveInFolder = createAsyncThunk(
  "ecards/moveInFolder",
  async ({ token, folderId, id }, { rejectWithValue }) => {


    try {

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/bio-pages/folders/move-in-folder`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            bioPageId: id, folderId
          }
        }
      );

      if (response.data.status) {

        return { id, response: response.data.response };
      } else {
        return rejectWithValue("Failed to Add in folder");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Error to add in folder "
      );
    }
  }
);

export const generateAvatarUrl = createAsyncThunk(
  "ecard/generate-avatar-url",
  async ({ token, avatar }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("avatar", avatar);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/common/uploader`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },

        }
      );
      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to load PDFs");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }

)

export const deleteEcard = createAsyncThunk(
  "ecard/delet-ecard",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      // console.log(id);
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/bio-pages/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return ({ id: id, response: response.data.response })
      } else {
        return rejectWithValue("Failed to delete E-Card");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);


export const getEcards = createAsyncThunk(
  "ecard/get-ecards",
  async ({ token, offset = 1, limit = 10, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bio-pages/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { offset, limit, onlyMy },
        }
      );
      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to load PDFs");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);


export const makeEcard = createAsyncThunk(
  'ecard/fetchECardData',
  async ({ token, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/bio-pages`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },

        }
      );
      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to load PDFs");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);

const eCardSlice = createSlice({
  name: 'ecard',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    removeFromFolderEcard: (state, action) => {
      const ecard = state.data.find(ecard => ecard.key === action.payload.key);
      if (ecard) {
        ecard.folderId = null;
      }
    },
    togglePinEcards: (state, action) => {
      const pin = state.data.find(item => item.key === action.payload.key);
      if (pin) {
        pin.pin = !pin.pin;
      }

      state.data = processLink(state.data);

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(makeEcard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(makeEcard.fulfilled, (state, action) => {
        state.loading = false;
        // state.data = action.payload;
        toast.success("E-card created successfully");
      })
      .addCase(makeEcard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload);
      })
      .addCase(getEcards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEcards.fulfilled, (state, action) => {
        state.loading = false;
        state.data = processLink(action.payload);
      })
      .addCase(getEcards.rejected, (state, action) => {
        state.loading = false;
        
      })
      .addCase(generateAvatarUrl.pending, (state) => {

      })
      .addCase(generateAvatarUrl.fulfilled, (state, action) => {
        toast.success("Avatar updated successfully")
      }).addCase(generateAvatarUrl.rejected, (state, action) => {
        toast(action.payload)
      })
      .addCase(EcardmoveInFolder.pending, (state, action) => {
        // state.loading = true
        state.error = null
      })
      .addCase(EcardmoveInFolder.fulfilled, (state, action) => {
        state.loading = false
        state.data = state.data.map((item) => {
          if (item.bioPageId === action.payload.id) {
            return { ...item, folderId: 1 };
          }
          return item;
        });
        toast(action.payload.response)
      })
      .addCase(EcardmoveInFolder.rejected, (state, action) => {
        state.loading = false
        toast(action.payload)
      })
      .addCase(EditEcard.pending, (state, action) => {
        state.loading = true

      })
      .addCase(EditEcard.fulfilled, (state, action) => {
        state.loading = false
        toast.success(action.payload)
      }).addCase(EditEcard.rejected, (state, action) => {
        state.loading = false
        toast.error(action.payload)
      })
      .addCase(deleteEcard.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteEcard.fulfilled, (state, action) => {
        state.loading = false
        state.data = state.data.filter((item) => item.bioPageId !== action.payload.id)
        toast.success(action.payload.response)
      }).addCase(deleteEcard.rejected, (state, action) => {
        state.loading = false
        toast.error(action.payload)
      })
      .addCase(toggleEcardKeyStatus.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(toggleEcardKeyStatus.fulfilled, (state, action) => {
        state.loading = false
        state.data = state.data.map((item) => {
          if (item.bioPageId === action.payload.id) {
            return { ...item, status: item.status === 1 ? 0 : 1 };
          }
          return item;
        });
        toast.success(action.payload.response)
      }).addCase(toggleEcardKeyStatus.rejected, (state, action) => {
        state.loading = false
        toast.error(action.payload)
      })
  },
});

export const { removeFromFolderEcard, togglePinEcards } = eCardSlice.actions;

export default eCardSlice.reducer;